export default __webpack_public_path__ + "static/media/logo-firefox.a9e6ca53.svg";